<template>
  <div>
      <div class="col-xl-12">
          <h2 class="fs-xxl fw-500 mt-4 text-white text-center">
              Восстановление пароля
              <small class="h3 fw-300 mt-3 mb-5 text-white opacity-60 hidden-sm-down">
                  Введите почтовый ящик и мы отправим на него код подтверждения для установки нового пароля.
              </small>
          </h2>
      </div>
      <div class="col-xl-6 ml-auto mr-auto">
          <div class="card p-4 rounded-plus bg-faded">
              <form data-form="restore" @submit.prevent="processRestore">
                  <div class="form-group">
                      <label class="form-label">Почтовый ящик</label>
                      <input type="email" data-input="mail" class="form-control" v-bind:class="{ 'is-invalid': 'mail' in errors}" v-on:focus="$delete(errors, 'mail')" v-model="mail" v-focus>
                      <div class="invalid-feedback" v-if="'mail' in errors">{{ errors['mail'] }}</div>
                  </div>
                  <div class="row no-gutters">
                      <div class="col-md-6 offset-md-3">
                          <button type="submit" data-button="restore" class="btn btn-block btn-success">Продолжить</button>
                      </div>
                  </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      title: 'Восстановление пароля',
    },
    data() {
      return {
        // Поля
        mail: '',
        // Ошибки
        errors: {}
      }
    },
    methods: {
      processRestore () 
      {
        // Отправка запроса к API
        this.$axios.post(process.env.VUE_APP_API_URL+'/v1/users/restore', {mail: this.mail}).then(response => 
        {
          if(response.data.status == 'success')
          {
            // Перенаправление на главную
            this.$router.push({name: 'account/restore/verify'});
          }
        }).catch(error => {
          // Собираем ошибки
          this.errors = {};
          $.each(error.response.data.errors, function(index, value) 
          {
            this.$set(this.errors, index, value[0])
          }.bind(this));
        });
      }
    }
  }
</script>